// extracted by mini-css-extract-plugin
module.exports = {"shorts":"styles_shorts__Bhbze"};